type PlaidIconProps = {
  size?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
};

export default function PlaidIcon({ size = 16, color, className, style }: PlaidIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 68 68"
      fill="none"
      className={className}
      style={{ color: color ?? undefined, ...style }}
    >
      <g filter="url(#filter0_dd_5537_1683)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.0329 7.60001L14.1767 11.452L10.0837 26.2432L15.204 31.4484L10 36.5677L13.8529 51.4243L28.6439 55.5163L33.8478 50.3959L38.9681 55.6L53.8233 51.748L57.9163 36.9547L52.797 31.7517L58 26.6323L54.1481 11.7757L39.3551 7.68375L34.1532 12.8031L29.0329 7.60001ZM19.9141 14.3002L27.7394 12.27L31.1614 15.7483L26.1709 20.6583L19.9141 14.3002ZM37.0996 15.7919L40.5768 12.3708L48.3684 14.5266L42.0095 20.7825L37.0996 15.7919ZM14.7695 25.0325L16.9253 17.2417L23.18 23.5998L18.1905 28.5098L14.7695 25.0325ZM44.9395 23.7682L51.2984 17.5112L53.3265 25.3378L49.8504 28.7589L44.9395 23.7682ZM29.1133 23.6429L34.1038 18.7329L39.0127 23.7236L34.0232 28.6336L29.1133 23.6429ZM21.1387 31.4915L26.1282 26.5815L31.0391 31.5722L26.0486 36.4822L21.1387 31.4915ZM36.9648 31.6292L41.9544 26.7192L46.8643 31.7099L41.8737 36.6199L36.9648 31.6292ZM14.6699 37.861L18.1481 34.439L23.057 39.4307L16.7 45.6856L14.6699 37.861ZM28.9902 39.4738L33.9808 34.5638L38.8907 39.5544L33.9011 44.4644L28.9902 39.4738ZM44.8164 39.6038L49.807 34.6939L53.229 38.1711L51.0732 45.9619L44.8164 39.6038ZM19.6387 48.6764L25.9966 42.4194L30.9075 47.4101L27.4303 50.8322L19.6387 48.6764ZM36.8359 47.4601L41.8255 42.5501L48.0813 48.9082L40.2569 50.9373L36.8359 47.4601Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_5537_1683"
          x="0.4"
          y="0.400006"
          width="67.2"
          height="67.2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.4" />
          <feGaussianBlur stdDeviation="4.8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0 0.0705882 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5537_1683" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0 0.0705882 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_5537_1683" result="effect2_dropShadow_5537_1683" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_5537_1683" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
